import React from "react";

export interface AudioCallbacks {
    onPlay?: () => void;
    onPause?: () => void;
    onEnd?: () => void;
    onError?: (error: Error) => void;
}

export interface AudioPlayerContextValue {
    play: (src: string, callbacks?: AudioCallbacks) => void;
    pause: () => void;
    resume: () => void;
    stop: () => void;
    isPlaying: boolean;
}

export const AudioPlayerContext = React.createContext<AudioPlayerContextValue>({
    play: () => void 0,
    pause: () => void 0,
    resume: () => void 0,
    stop: () => void 0,
    isPlaying: false,
});

if (__DEV__) {
    AudioPlayerContext.displayName = "AudioPlayerContext";
}
